import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import AboutPage from "./pages/AboutPage/AboutPage";
import PageTemplate from "./pages/PageTemplate/PageTemplate";
import Error404 from "./pages/Error404/Error404";
import VehicleClassesPage from "./pages/Settings/VehicleClassesPage/VehicleClassesPage";
import VehicleTypesPage from "./pages/Settings/VehicleTypesPage/VehicleTypesPage";
import VehicleBrandsPage from "./pages/Settings/VehicleBrandsPage/VehicleBrandsPage";
import ServiceTypesPage from "./pages/Settings/ServiceTypesPage/ServiceTypesPage";
import BranchPage from "./pages/Settings/BranchPage/BranchPage";
import SeasonsPage from "./pages/Settings/SeasonsPage/SeasonsPage";
import CurrencyPage from "./pages/Settings/CurrencyPage/CurrencyPage";
import CurrencyExchangePage from "./pages/Settings/CurrencyExchangePage/CurrencyExchangePage";
import FleetLocationsPage from "./pages/Settings/FleetLocationsPage/FleetLocationsPage";
import VehicleModelsPage from "./pages/Settings/VehicleModelsPage/VehicleModelsPage";
import ColorsPage from "./pages/Settings/ColorsPage/ColorsPage";
import ExtrasCategoriesPage from "./pages/Settings/ExtrasCategoriesPage/ExtrasCategoriesPage";
import ExtrasPage from "./pages/Settings/ExtrasPage/ExtrasPage";
import CompanyPage from "./pages/Settings/CompanyPage/CompanyPage";
import ExtrasRatesPage from "./pages/Settings/ExtrasRatesPage/ExtrasRatesPage";
import RatesPage from "./pages/Settings/RatesPage/RatesPage";
import VehiclesPage from "./pages/VehiclesPage/VehiclesPage";
import DamageTypesPage from "./pages/Settings/DamageTypesPage/DamageTypesPage";
import CustomersPage from "./pages/CustomersPage/CustomersPage";
import ReservationPage from "./pages/ReservationPage/ReservationPage";
import CityPage from "./pages/CityPage/CityPage";

import "./App.css";
import MileageOptionsPage from "./pages/Settings/MileageOptionsPage/MileageOptionsPage";
import MileageOptionRatePage from "./pages/Settings/MileageOptionRatePage/MileageOptionRatePage";
import CoverageOptionsPage from "./pages/Settings/CoverageOptionsPage/CoverageOptionsPage";
import CoverageOptionRatePage from "./pages/Settings/CoverageOptionRatePage/CoverageOptionRatePage";
import UsersPage from "./pages/UsersPage/UsersPage";
import DeliveryRatesPage from "./pages/Settings/DeliveryRatesPage/DeliveryRatesPage";
import ChangelogsPage from "./pages/ChangelogsPage/ChangelogsPage";
import ReservationDetailsPage from "./pages/ReservationPage/ReservationDetailsPage";
import VehiclesDetailsPage from "./pages/VehiclesPage/VehicleDetailsPage";
import CustomersDetailsPage from "./pages/CustomersPage/CustomersDetailsPage";
import UsersDetailsPage from "./pages/UsersPage/UsersDetailsPage";
import CompanyDetailsPage from "./pages/Settings/CompanyPage/CompanyDetailsPage";
import CityDetailsPage from "./pages/CityPage/CityDetailPage";
import BranchDetailsPage from "./pages/Settings/BranchPage/BranchDetailsPage";
import FleetLocationsDetailsPage from "./pages/Settings/FleetLocationsPage/FleetLocationsDetailsPage";
import VehicleTypesDetailsPage from "./pages/Settings/VehicleTypesPage/VehicleTypesDetailsPage";
import VehicleBrandsDetailsPage from "./pages/Settings/VehicleBrandsPage/VehicleBrandsDetailsPage";
import VehicleModelsDetailsPage from "./pages/Settings/VehicleModelsPage/VehicleModelsDetailsPage";
import VehicleClassesDetailsPage from "./pages/Settings/VehicleClassesPage/VehicleClassesDetailsPage";
import ColorsDetailsPage from "./pages/Settings/ColorsPage/ColorsDetailsPage";
import DamageTypesDetailsPage from "./pages/Settings/DamageTypesPage/DamageTypesDetailsPage";
import ExtrasCategoriesDetailsPage from "./pages/Settings/ExtrasCategoriesPage/ExtrasCategoriesDetailsPage";
import ExtrasDetailsPage from "./pages/Settings/ExtrasPage/ExtrasDetailsPage";
import MileageOptionRateDetailsPage from "./pages/Settings/MileageOptionRatePage/MileageOptionRateDetailsPage";
import MileageOptionsDetailsPage from "./pages/Settings/MileageOptionsPage/MileageOptionsDetailsPage";
import CoverageOptionsDetailsPage from "./pages/Settings/CoverageOptionsPage/CoverageOptionsDetailsPage";
import SeasonsDetailsPage from "./pages/Settings/SeasonsPage/SeasonsDetailsPage";
import RatesDetailsPage from "./pages/Settings/RatesPage/RatesDetailsPage";
import ExtrasRatesDetailsPage from "./pages/Settings/ExtrasRatesPage/ExtrasRatesDetailsPage";
import CoverageOptionRateDetailsPage from "./pages/Settings/CoverageOptionRatePage/CoverageOptionRateDetailsPage";
import DeliveryRatesDetailsPage from "./pages/Settings/DeliveryRatesPage/DeliveryRatesDetailsPage";
import CurrencyDetailsPage from "./pages/Settings/CurrencyPage/CurrencyDetailsPage";
import CurrencyExchangeDetailsPage from "./pages/Settings/CurrencyExchangePage/CurrencyExchangeDetailsPage";

import ReportPage from "./pages/ReportsPage/ReportPage";
import RentalPartnersPage from "./pages/RentalPartnersPage/RentalPartnersPage";
import AccountStatementPage from "./pages/ReportsPage/AccountStatementPage";
import SmartBillPage from "./pages/SmartBillPage/SmartBillPage";
import GeneralPage from "./pages/Settings/GeneralPage/GeneralPage";

const App = () => {
  return (
    <Router>
      <PageTemplate>
        <Routes>
          <Route exact path="/" element={<DashboardPage />} />
          <Route exact path="/about" element={<AboutPage />} />

          <Route
            exact
            path="/vehicleclasses"
            element={<VehicleClassesPage />}
          />
          <Route
            exact
            path="/vehicleclasses/:id"
            element={<VehicleClassesDetailsPage />}
          />

          <Route exact path="/vehicletypes" element={<VehicleTypesPage />} />
          <Route
            exact
            path="/vehicletypes/:id"
            element={<VehicleTypesDetailsPage />}
          />

          <Route exact path="/vehiclebrands" element={<VehicleBrandsPage />} />
          <Route
            exact
            path="/vehiclebrands/:id"
            element={<VehicleBrandsDetailsPage />}
          />

          <Route exact path="/servicetypes" element={<ServiceTypesPage />} />

          <Route exact path="/branches" element={<BranchPage />} />
          <Route exact path="/branches/:id" element={<BranchDetailsPage />} />

          <Route exact path="/seasons" element={<SeasonsPage />} />
          <Route exact path="/seasons/:id" element={<SeasonsDetailsPage />} />

          <Route exact path="/currencies" element={<CurrencyPage />} />
          <Route
            exact
            path="/currencies/:id"
            element={<CurrencyDetailsPage />}
          />

          <Route
            exact
            path="/currencyexchanges"
            element={<CurrencyExchangePage />}
          />
          <Route
            exact
            path="/currencyexchanges/:id"
            element={<CurrencyExchangeDetailsPage />}
          />

          <Route
            exact
            path="/fleetlocations"
            element={<FleetLocationsPage />}
          />
          <Route
            exact
            path="/fleetlocations/:id"
            element={<FleetLocationsDetailsPage />}
          />

          <Route exact path="/vehiclemodels" element={<VehicleModelsPage />} />
          <Route
            exact
            path="/vehiclemodels/:id"
            element={<VehicleModelsDetailsPage />}
          />

          <Route exact path="/colors" element={<ColorsPage />} />
          <Route exact path="/colors/:id" element={<ColorsDetailsPage />} />

          <Route
            exact
            path="/addoncategories"
            element={<ExtrasCategoriesPage />}
          />
          <Route
            exact
            path="/addoncategories/:id"
            element={<ExtrasCategoriesDetailsPage />}
          />

          <Route exact path="/addons" element={<ExtrasPage />} />
          <Route exact path="/addons/:id" element={<ExtrasDetailsPage />} />

          <Route exact path="/changelogs" element={<ChangelogsPage />} />

          <Route exact path="/companies" element={<CompanyPage />} />
          <Route exact path="/companies/:id" element={<CompanyDetailsPage />} />

          <Route exact path="/cities" element={<CityPage />} />
          <Route exact path="/cities/:id" element={<CityDetailsPage />} />



          <Route exact path="/extrasrates" element={<ExtrasRatesPage />} />
          <Route
            exact
            path="/extrasrates/:id"
            element={<ExtrasRatesDetailsPage />}
          />

          <Route exact path="/vehiclerates" element={<RatesPage />} />
          <Route
            exact
            path="/vehiclerates/:id"
            element={<RatesDetailsPage />}
          />

          <Route exact path="/vehicles" element={<VehiclesPage />} />
          <Route exact path="/vehicles/:id" element={<VehiclesDetailsPage />} />

          <Route exact path="/damagetypes" element={<DamageTypesPage />} />
          <Route
            exact
            path="/damagetypes/:id"
            element={<DamageTypesDetailsPage />}
          />

          <Route exact path="/customers" element={<CustomersPage />} />
          <Route
            exact
            path="/customers/:id"
            element={<CustomersDetailsPage />}
          />

          <Route exact path="/reservations" element={<ReservationPage />} />
          <Route
            exact
            path="/reservations/:id"
            element={<ReservationDetailsPage />}
          />



          <Route
            exact
            path="/mileageoptions"
            element={<MileageOptionsPage />}
          />
          <Route
            exact
            path="/mileageoptions/:id"
            element={<MileageOptionsDetailsPage />}
          />

          <Route
            exact
            path="/mileageoptionsrates"
            element={<MileageOptionRatePage />}
          />
          <Route
            exact
            path="/mileageoptionsrates/:id"
            element={<MileageOptionRateDetailsPage />}
          />

          <Route
            exact
            path="/coverageoptions"
            element={<CoverageOptionsPage />}
          />
          <Route
            exact
            path="/coverageoptions/:id"
            element={<CoverageOptionsDetailsPage />}
          />

          <Route
            exact
            path="/coverageoptionsrates"
            element={<CoverageOptionRatePage />}
          />
          <Route
            exact
            path="/coverageoptionsrates/:id"
            element={<CoverageOptionRateDetailsPage />}
          />

          <Route exact path="/deliveryrates" element={<DeliveryRatesPage />} />
          <Route
            exact
            path="/deliveryrates/:id"
            element={<DeliveryRatesDetailsPage />}
          />

          <Route exact path="/users" element={<UsersPage />} />
          <Route exact path="/users/:id" element={<UsersDetailsPage />} />

          <Route exact path="/rental-partners" element={<RentalPartnersPage />} />

          <Route exact path="/smart-bill" element={<SmartBillPage />} />
          
          <Route exact path="/reports" element={<ReportPage />} />
          <Route exact path="/account-statement" element={<AccountStatementPage />} />

          <Route exact path="/general-settings" element={<GeneralPage />} />

          <Route exact path="*" element={<Error404 />} />
        </Routes>
      </PageTemplate>
    </Router>
  );
};

export default App;
